"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _finance = require("@/api/finance");
var _view = _interopRequireDefault(require("./view"));
var _remark = _interopRequireDefault(require("./remark"));
var _phoneLock = _interopRequireDefault(require("./phoneLock"));
var _hasSueStatus = _interopRequireDefault(require("./hasSueStatus"));
var _merchant = require("@/api/merchant");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default,
    myDatePicker: _myDatePicker.default,
    viewDialog: _view.default,
    remarkDialog: _remark.default,
    phoneLockDialog: _phoneLock.default,
    hasSueStatus: _hasSueStatus.default
  },
  data: function data() {
    return {
      searchForm: {
        orderNo: '',
        goodsName: '',
        receivingName: '',
        receivingMobile: '',
        sendStatus: '',
        min: '',
        max: '',
        leaseTime: '',
        // is_sue:'1',
        merchant_child_id: 0,
        lock_status: '',
        merchantId: '',
        lease_sue: '1'
      },
      tableData: [],
      total: 0,
      overdueCount: 0,
      overdueAmount: 0,
      selectedItem: {},
      merchantList: [],
      merchantId: 0,
      merchantIdS: [],
      merchantChild: [{
        'id': 0,
        'username': "全部"
      }]
    };
  },
  methods: {
    batchSend: function batchSend() {
      var _this = this;
      var list = this.$refs.multipleTable.selection;
      if (list.length === 0) {
        this.$message({
          message: "没有勾选项",
          type: "warning"
        });
        return;
      }
      var ids = list.map(function (k) {
        return k.lease_id;
      }).join(',');
      (0, _finance.sendOverdueSms)(ids).then(function (res) {
        _this.getList();
      });
    },
    // 发起代扣
    withholdItem: function withholdItem(orderId, leaseId) {
      var _this2 = this;
      this.$confirm("您确定要发起代扣吗？", "发起代扣", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _finance.manualWithholding)({
          orderId: orderId,
          leaseId: leaseId
        }).then(function (res) {
          setTimeout(function () {
            _this2.getList();
          }, 1000);
        });
      }).catch(function () {});
    },
    handleMore: function handleMore(command, item) {
      this.selectedItem = item;
      if (command == 1) {
        // 查看记录
        this.$refs.viewDialog.dialogVisible = true;
      } else {
        // 查看备注
        this.$refs.remarkDialog.dialogVisible = true;
      }
    },
    goToOrder: function goToOrder(orderId) {
      if (orderId) {
        var routeData = this.$router.resolve({
          name: "orderList",
          query: {
            orderId: orderId
          }
        });
        this.$func.openWindow(routeData.href);
      }
    },
    exportFile: function exportFile() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal == 'error') {
        return;
      }
      this.searchForm.leaseTime = pickerVal;
      var params = (0, _objectSpread2.default)({}, this.searchForm);
      params.overdueDay = params.min && params.max ? params.min + '~' + params.max : '';
      delete params.min;
      delete params.max;
      (0, _finance.overdueListExport)(params);
    },
    changeNumberInput: function changeNumberInput(key, value) {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时
      if (!pattern.test(value)) {
        // input 框绑定的内容为空
        this.searchForm[key] = '';
      }
    },
    // 获取数据
    getList: function getList() {
      var _this3 = this;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      var params = (0, _objectSpread2.default)({}, this.searchForm);
      params.overdueDay = params.min && params.max ? params.min + '~' + params.max : '';
      delete params.min;
      delete params.max;
      (0, _finance.financeOverdueList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, params)).then(function (res) {
        var _res$list = res.list,
          data = _res$list.data,
          total = _res$list.total,
          _res$count = res.count,
          overdueCount = _res$count.overdueCount,
          overdueAmount = _res$count.overdueAmount;
        _this3.tableData = data || [];
        _this3.total = total || 0;
        _this3.overdueCount = overdueCount;
        _this3.overdueAmount = overdueAmount;
      });
    },
    // 查询
    search: function search() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal == 'error') {
        return;
      }
      this.searchForm.leaseTime = pickerVal;
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      if (this.$refs.myDatePicker) {
        this.$refs.myDatePicker.reset();
      }
      this.searchForm = {
        orderNo: '',
        goodsName: '',
        receivingName: '',
        receivingMobile: '',
        sendStatus: '',
        min: '',
        max: '',
        leaseTime: ''
      };
      this.getList();
    },
    is_sue: function is_sue(item) {
      this.selectedItem = item;
      this.$refs.hasSueStatus.dialogVisible = true;
    },
    saveOverdueLock: function saveOverdueLock(item) {
      this.selectedItem = item;
      this.$refs.phoneLockDialog.dialogVisible = true;
    },
    is_sue_class: function is_sue_class(is_sue) {
      switch (is_sue) {
        case 0:
          return "blue-font";
        case 1:
          return "red-font";
        case 2:
          return "warning-font";
      }
    },
    getQuery: function getQuery() {
      var _this4 = this;
      (0, _finance.financeOverdueQuery)().then(function (res) {
        var _this4$merchantChild;
        (_this4$merchantChild = _this4.merchantChild).push.apply(_this4$merchantChild, (0, _toConsumableArray2.default)(res.data));
      });
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    merchantIdChangeString: function merchantIdChangeString(val) {
      this.searchForm.merchantId = val.join(',');
    }
  },
  mounted: function mounted() {
    this.getMerchantList();
    this.getQuery();
    this.getList();
    this.merchantId = (0, _auth.getMerchantId)() || 0;
  }
};
exports.default = _default;